<template>
  <div>
    <!-- dont show upsell product for BAG -->
  </div>
</template>
